/* Public catalog reconciliation. No network/commerce transport. Decisions and fulfillment remain blocked. */
(function(root){
const registry={
  "version": "emanuel-catalog-20261029",
  "enabled": false,
  "purchaseEnabled": false,
  "currency": "USD",
  "screenshotTags": [
    "miamimd-co-pricing",
    "trymiamimd-price"
  ],
  "observedCoTag": "miamimd-co-price",
  "activeProfiles": {
    "acf": "approved-existing-39-103-192",
    "lf": "proposal-existing-20pct-blocked"
  },
  "defaultPricingChangeApproved": false,
  "warehouseVerified": false,
  "records": [
    {
      "key": "tbm",
      "family": "special",
      "kind": "special",
      "pack": 6,
      "productId": 15485392650525,
      "variantId": 67912166113565,
      "sku": "MMTBM-6B",
      "handle": "miamimd-total-beauty-matrix-6-jars-special",
      "title": "MiamiMD Total Beauty Matrix 6 Jars (Special)",
      "tags": [
        "miamimd-co-import-20261029",
        "Special"
      ],
      "priceCents": 18000,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:59:06-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-total-beauty-matrix-6-jars-special.js"
    },
    {
      "key": "tbm",
      "family": "special",
      "kind": "special",
      "pack": 3,
      "productId": 15485392453917,
      "variantId": 67912163655965,
      "sku": "MMTBM-3B",
      "handle": "miamimd-total-beauty-matrix-3-jars-special",
      "title": "MiamiMD Total Beauty Matrix 3 Jars (Special)",
      "tags": [
        "miamimd-co-import-20261029",
        "Special"
      ],
      "priceCents": 9900,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:59:05-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-total-beauty-matrix-3-jars-special.js"
    },
    {
      "key": "tbm",
      "family": "special",
      "kind": "special",
      "pack": 1,
      "productId": 15485392257309,
      "variantId": 67912160608541,
      "sku": "MMTBM-1B",
      "handle": "miamimd-total-beauty-matrix-1-jar-special",
      "title": "MiamiMD Total Beauty Matrix 1 Jar (Special)",
      "tags": [
        "miamimd-co-import-20261029",
        "Special"
      ],
      "priceCents": 3300,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:59:03-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-total-beauty-matrix-1-jar-special.js"
    },
    {
      "key": "tbm",
      "family": "miamimd-co",
      "kind": "subscription",
      "pack": 6,
      "productId": 15485392027933,
      "variantId": 67912157921565,
      "sku": "MMTBM-6B",
      "handle": "miamimd-total-beauty-matrix-6-jars-subscription-mmdco",
      "title": "MiamiMD Total Beauty Matrix 6 Jars (Subscription)",
      "tags": [
        "miamimd-co-import-20261029",
        "miamimd-co-price"
      ],
      "priceCents": 32400,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:59:01-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-total-beauty-matrix-6-jars-subscription-mmdco.js"
    },
    {
      "key": "tbm",
      "family": "miamimd-co",
      "kind": "subscription",
      "pack": 3,
      "productId": 15485391831325,
      "variantId": 67912155463965,
      "sku": "MMTBM-3B",
      "handle": "miamimd-total-beauty-matrix-3-jars-subscription-mmdco",
      "title": "MiamiMD Total Beauty Matrix 3 Jars (Subscription)",
      "tags": [
        "miamimd-co-import-20261029",
        "miamimd-co-price"
      ],
      "priceCents": 17100,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:59:00-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-total-beauty-matrix-3-jars-subscription-mmdco.js"
    },
    {
      "key": "tbm",
      "family": "miamimd-co",
      "kind": "subscription",
      "pack": 1,
      "productId": 15485391634717,
      "variantId": 67912153006365,
      "sku": "MMTBM-1B",
      "handle": "miamimd-total-beauty-matrix-1-jar-subscription-mmdco",
      "title": "MiamiMD Total Beauty Matrix 1 Jar (Subscription)",
      "tags": [
        "miamimd-co-import-20261029",
        "miamimd-co-price"
      ],
      "priceCents": 6200,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:58:58-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-total-beauty-matrix-1-jar-subscription-mmdco.js"
    },
    {
      "key": "tbm",
      "family": "miamimd-co",
      "kind": "one-time",
      "pack": 6,
      "productId": 15485391438109,
      "variantId": 67912150548765,
      "sku": "MMTBM-6B",
      "handle": "miamimd-total-beauty-matrix-6-jars-mmdco",
      "title": "MiamiMD Total Beauty Matrix 6 Jars",
      "tags": [
        "miamimd-co-import-20261029",
        "miamimd-co-price"
      ],
      "priceCents": 36000,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:58:56-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-total-beauty-matrix-6-jars-mmdco.js"
    },
    {
      "key": "tbm",
      "family": "miamimd-co",
      "kind": "one-time",
      "pack": 3,
      "productId": 15485391208733,
      "variantId": 67912147501341,
      "sku": "MMTBM-3B",
      "handle": "miamimd-total-beauty-matrix-3-jars-mmdco",
      "title": "MiamiMD Total Beauty Matrix 3 Jars",
      "tags": [
        "miamimd-co-import-20261029",
        "miamimd-co-price"
      ],
      "priceCents": 18900,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:58:55-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": true,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-total-beauty-matrix-3-jars-mmdco.js"
    },
    {
      "key": "tbm",
      "family": "miamimd-co",
      "kind": "one-time",
      "pack": 1,
      "productId": 15485391044893,
      "variantId": 67912145076509,
      "sku": "MMTBM-1B",
      "handle": "miamimd-total-beauty-matrix-1-jar-mmdco",
      "title": "MiamiMD Total Beauty Matrix 1 Jar",
      "tags": [
        "miamimd-co-import-20261029",
        "miamimd-co-price"
      ],
      "priceCents": 6900,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:58:53-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": true,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-total-beauty-matrix-1-jar-mmdco.js"
    },
    {
      "key": "tbm",
      "family": "trymiamimd",
      "kind": "subscription",
      "pack": 6,
      "productId": 15485390881053,
      "variantId": 67912143798557,
      "sku": "MMTBM-6B",
      "handle": "miamimd-total-beauty-matrix-6-jars-subscription",
      "title": "MiamiMD Total Beauty Matrix 6 Jars (Subscription)",
      "tags": [
        "miamimd-co-import-20261029",
        "trymiamimd-price"
      ],
      "priceCents": 21600,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:58:51-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-total-beauty-matrix-6-jars-subscription.js"
    },
    {
      "key": "tbm",
      "family": "trymiamimd",
      "kind": "subscription",
      "pack": 3,
      "productId": 15485390782749,
      "variantId": 67912143110429,
      "sku": "MMTBM-3B",
      "handle": "miamimd-total-beauty-matrix-3-jars-subscription",
      "title": "MiamiMD Total Beauty Matrix 3 Jars (Subscription)",
      "tags": [
        "miamimd-co-import-20261029",
        "trymiamimd-price"
      ],
      "priceCents": 11700,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:58:50-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": true,
      "plans": [
        {
          "id": 691076989213,
          "rechargePlanId": "23631768",
          "appId": "294517",
          "interval": "MONTH",
          "intervalCount": 1,
          "cadenceEvidence": "structured selling-plan option, not plan name",
          "priceCents": 11700,
          "perDeliveryPriceCents": 11700,
          "allocationVerified": true,
          "billingPolicyAdminVerified": false,
          "rechargeProductQuantityOption": "0"
        },
        {
          "id": 691077021981,
          "rechargePlanId": "23631769",
          "appId": "294517",
          "interval": "MONTH",
          "intervalCount": 3,
          "cadenceEvidence": "structured selling-plan option, not plan name",
          "priceCents": 11700,
          "perDeliveryPriceCents": 11700,
          "allocationVerified": true,
          "billingPolicyAdminVerified": false,
          "rechargeProductQuantityOption": "0"
        },
        {
          "id": 691077054749,
          "rechargePlanId": "23631770",
          "appId": "294517",
          "interval": "MONTH",
          "intervalCount": 6,
          "cadenceEvidence": "structured selling-plan option, not plan name",
          "priceCents": 11700,
          "perDeliveryPriceCents": 11700,
          "allocationVerified": true,
          "billingPolicyAdminVerified": false,
          "rechargeProductQuantityOption": "0"
        }
      ],
      "source": "https://crepe.trymiamimd.com/products/miamimd-total-beauty-matrix-3-jars-subscription.js"
    },
    {
      "key": "tbm",
      "family": "trymiamimd",
      "kind": "subscription",
      "pack": 1,
      "productId": 15485390618909,
      "variantId": 67912141242653,
      "sku": "MMTBM-1B",
      "handle": "miamimd-total-beauty-matrix-1-jar-subscription",
      "title": "MiamiMD Total Beauty Matrix 1 Jar (Subscription)",
      "tags": [
        "miamimd-co-import-20261029",
        "trymiamimd-price"
      ],
      "priceCents": 4400,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:58:48-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-total-beauty-matrix-1-jar-subscription.js"
    },
    {
      "key": "lip",
      "family": "special",
      "kind": "special",
      "pack": 6,
      "productId": 15485385179421,
      "variantId": 67912078491933,
      "sku": "MMLP-6B",
      "handle": "miamimd-lip-plumper-6-bottles-special",
      "title": "MiamiMD Lip Plumper 6 Bottles (Special)",
      "tags": [
        "miamimd-co-import-20261029",
        "Special"
      ],
      "priceCents": 18000,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:58:07-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-lip-plumper-6-bottles-special.js"
    },
    {
      "key": "lip",
      "family": "special",
      "kind": "special",
      "pack": 3,
      "productId": 15485385048349,
      "variantId": 67912077771037,
      "sku": "MMLP-3B",
      "handle": "miamimd-lip-plumper-3-bottles-special",
      "title": "MiamiMD Lip Plumper 3 Bottles (Special)",
      "tags": [
        "miamimd-co-import-20261029",
        "Special"
      ],
      "priceCents": 9900,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:58:05-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": true,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-lip-plumper-3-bottles-special.js"
    },
    {
      "key": "lip",
      "family": "special",
      "kind": "special",
      "pack": 1,
      "productId": 15485384884509,
      "variantId": 67912075903261,
      "sku": "MMLP-1B",
      "handle": "miamimd-lip-plumper-1-bottle-special",
      "title": "MiamiMD Lip Plumper 1 Bottle (Special)",
      "tags": [
        "miamimd-co-import-20261029",
        "Special"
      ],
      "priceCents": 3300,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:58:04-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-lip-plumper-1-bottle-special.js"
    },
    {
      "key": "lip",
      "family": "miamimd-co",
      "kind": "subscription",
      "pack": 6,
      "productId": 15485384687901,
      "variantId": 67912073249053,
      "sku": "MMLP-6B",
      "handle": "miamimd-lip-plumper-6-bottles-subscription-mmdco",
      "title": "MiamiMD Lip Plumper 6 Bottles (Subscription)",
      "tags": [
        "miamimd-co-import-20261029",
        "miamimd-co-price"
      ],
      "priceCents": 32400,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:58:02-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-lip-plumper-6-bottles-subscription-mmdco.js"
    },
    {
      "key": "lip",
      "family": "miamimd-co",
      "kind": "subscription",
      "pack": 3,
      "productId": 15485384491293,
      "variantId": 67912071250205,
      "sku": "MMLP-3B",
      "handle": "miamimd-lip-plumper-3-bottles-subscription-mmdco",
      "title": "MiamiMD Lip Plumper 3 Bottles (Subscription)",
      "tags": [
        "miamimd-co-import-20261029",
        "miamimd-co-price"
      ],
      "priceCents": 17100,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:58:00-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-lip-plumper-3-bottles-subscription-mmdco.js"
    },
    {
      "key": "lip",
      "family": "miamimd-co",
      "kind": "subscription",
      "pack": 1,
      "productId": 15485384327453,
      "variantId": 67912069382429,
      "sku": "MMLP-1B",
      "handle": "miamimd-lip-plumper-1-bottle-subscription-mmdco",
      "title": "MiamiMD Lip Plumper 1 Bottle (Subscription)",
      "tags": [
        "miamimd-co-import-20261029",
        "miamimd-co-price"
      ],
      "priceCents": 6200,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:57:59-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-lip-plumper-1-bottle-subscription-mmdco.js"
    },
    {
      "key": "lip",
      "family": "miamimd-co",
      "kind": "one-time",
      "pack": 6,
      "productId": 15485384130845,
      "variantId": 67912066990365,
      "sku": "MMLP-6B",
      "handle": "miamimd-lip-plumper-6-bottles-mmdco",
      "title": "MiamiMD Lip Plumper 6 Bottles",
      "tags": [
        "miamimd-co-import-20261029",
        "miamimd-co-price"
      ],
      "priceCents": 36000,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:57:57-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-lip-plumper-6-bottles-mmdco.js"
    },
    {
      "key": "lip",
      "family": "miamimd-co",
      "kind": "one-time",
      "pack": 3,
      "productId": 15485383967005,
      "variantId": 67912063877405,
      "sku": "MMLP-3B",
      "handle": "miamimd-lip-plumper-3-bottles-mmdco",
      "title": "MiamiMD Lip Plumper 3 Bottles",
      "tags": [
        "miamimd-co-import-20261029",
        "miamimd-co-price"
      ],
      "priceCents": 18900,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:57:55-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": true,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-lip-plumper-3-bottles-mmdco.js"
    },
    {
      "key": "lip",
      "family": "miamimd-co",
      "kind": "one-time",
      "pack": 1,
      "productId": 15485383770397,
      "variantId": 67912061976861,
      "sku": "MMLP-1B",
      "handle": "miamimd-lip-plumper-1-bottle-mmdco",
      "title": "MiamiMD Lip Plumper 1 Bottle",
      "tags": [
        "miamimd-co-import-20261029",
        "miamimd-co-price"
      ],
      "priceCents": 6900,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:57:54-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-lip-plumper-1-bottle-mmdco.js"
    },
    {
      "key": "lip",
      "family": "trymiamimd",
      "kind": "subscription",
      "pack": 6,
      "productId": 15485383606557,
      "variantId": 67912060109085,
      "sku": "MMLP-6B",
      "handle": "miamimd-lip-plumper-6-bottles-subscription",
      "title": "MiamiMD Lip Plumper 6 Bottles (Subscription)",
      "tags": [
        "miamimd-co-import-20261029",
        "trymiamimd-price"
      ],
      "priceCents": 21600,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:57:52-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-lip-plumper-6-bottles-subscription.js"
    },
    {
      "key": "lip",
      "family": "trymiamimd",
      "kind": "subscription",
      "pack": 3,
      "productId": 15485383508253,
      "variantId": 67912059420957,
      "sku": "MMLP-3B",
      "handle": "miamimd-lip-plumper-3-bottles-subscription",
      "title": "MiamiMD Lip Plumper 3 Bottles (Subscription)",
      "tags": [
        "miamimd-co-import-20261029",
        "trymiamimd-price"
      ],
      "priceCents": 11700,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:57:51-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": true,
      "plans": [
        {
          "id": 691075383581,
          "rechargePlanId": "23631714",
          "appId": "294517",
          "interval": "MONTH",
          "intervalCount": 1,
          "cadenceEvidence": "structured selling-plan option, not plan name",
          "priceCents": 11700,
          "perDeliveryPriceCents": 11700,
          "allocationVerified": true,
          "billingPolicyAdminVerified": false,
          "rechargeProductQuantityOption": "0"
        },
        {
          "id": 691075416349,
          "rechargePlanId": "23631715",
          "appId": "294517",
          "interval": "MONTH",
          "intervalCount": 3,
          "cadenceEvidence": "structured selling-plan option, not plan name",
          "priceCents": 11700,
          "perDeliveryPriceCents": 11700,
          "allocationVerified": true,
          "billingPolicyAdminVerified": false,
          "rechargeProductQuantityOption": "0"
        },
        {
          "id": 691075449117,
          "rechargePlanId": "23631716",
          "appId": "294517",
          "interval": "MONTH",
          "intervalCount": 6,
          "cadenceEvidence": "structured selling-plan option, not plan name",
          "priceCents": 11700,
          "perDeliveryPriceCents": 11700,
          "allocationVerified": true,
          "billingPolicyAdminVerified": false,
          "rechargeProductQuantityOption": "0"
        }
      ],
      "source": "https://crepe.trymiamimd.com/products/miamimd-lip-plumper-3-bottles-subscription.js"
    },
    {
      "key": "lip",
      "family": "trymiamimd",
      "kind": "subscription",
      "pack": 1,
      "productId": 15485383442717,
      "variantId": 67912058765597,
      "sku": "MMLP-1B",
      "handle": "miamimd-lip-plumper-1-bottle-subscription",
      "title": "MiamiMD Lip Plumper 1 Bottle (Subscription)",
      "tags": [
        "miamimd-co-import-20261029",
        "trymiamimd-price"
      ],
      "priceCents": 4400,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:57:49-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-lip-plumper-1-bottle-subscription.js"
    },
    {
      "key": "iwe",
      "family": "special",
      "kind": "special",
      "pack": 6,
      "productId": 15485379576093,
      "variantId": 67912017346845,
      "sku": "MMIWE-6B",
      "handle": "miamimd-instant-wrinkle-eraser-6-bottles-special",
      "title": "MiamiMD Instant Wrinkle Eraser 6 Bottles (Special)",
      "tags": [
        "miamimd-co-import-20261029",
        "Special"
      ],
      "priceCents": 18000,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:57:27-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-instant-wrinkle-eraser-6-bottles-special.js"
    },
    {
      "key": "iwe",
      "family": "special",
      "kind": "special",
      "pack": 3,
      "productId": 15485379346717,
      "variantId": 67912014856477,
      "sku": "MMIWE-3B",
      "handle": "miamimd-instant-wrinkle-eraser-3-bottles-special",
      "title": "MiamiMD Instant Wrinkle Eraser 3 Bottles (Special)",
      "tags": [
        "miamimd-co-import-20261029",
        "Special"
      ],
      "priceCents": 9900,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:57:25-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-instant-wrinkle-eraser-3-bottles-special.js"
    },
    {
      "key": "iwe",
      "family": "special",
      "kind": "special",
      "pack": 1,
      "productId": 15485379182877,
      "variantId": 67912012398877,
      "sku": "MMIWE-1B",
      "handle": "miamimd-instant-wrinkle-eraser-1-bottle-special",
      "title": "MiamiMD Instant Wrinkle Eraser 1 Bottle (Special)",
      "tags": [
        "miamimd-co-import-20261029",
        "Special"
      ],
      "priceCents": 3300,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:57:24-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-instant-wrinkle-eraser-1-bottle-special.js"
    },
    {
      "key": "iwe",
      "family": "miamimd-co",
      "kind": "subscription",
      "pack": 6,
      "productId": 15485378986269,
      "variantId": 67912010531101,
      "sku": "MMIWE-6B",
      "handle": "miamimd-instant-wrinkle-eraser-6-bottles-subscription-mmdco",
      "title": "MiamiMD Instant Wrinkle Eraser 6 Bottles (Subscription)",
      "tags": [
        "miamimd-co-import-20261029",
        "miamimd-co-price"
      ],
      "priceCents": 32400,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:57:22-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-instant-wrinkle-eraser-6-bottles-subscription-mmdco.js"
    },
    {
      "key": "iwe",
      "family": "miamimd-co",
      "kind": "subscription",
      "pack": 3,
      "productId": 15485378855197,
      "variantId": 67912008728861,
      "sku": "MMIWE-3B",
      "handle": "miamimd-instant-wrinkle-eraser-3-bottles-subscription-mmdco",
      "title": "MiamiMD Instant Wrinkle Eraser 3 Bottles (Subscription)",
      "tags": [
        "miamimd-co-import-20261029",
        "miamimd-co-price"
      ],
      "priceCents": 17100,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:57:20-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-instant-wrinkle-eraser-3-bottles-subscription-mmdco.js"
    },
    {
      "key": "iwe",
      "family": "miamimd-co",
      "kind": "subscription",
      "pack": 1,
      "productId": 15485378625821,
      "variantId": 67912006238493,
      "sku": "MMIWE-1B",
      "handle": "miamimd-instant-wrinkle-eraser-1-bottle-subscription-mmdco",
      "title": "MiamiMD Instant Wrinkle Eraser 1 Bottle (Subscription)",
      "tags": [
        "miamimd-co-import-20261029",
        "miamimd-co-price"
      ],
      "priceCents": 6200,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:57:19-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-instant-wrinkle-eraser-1-bottle-subscription-mmdco.js"
    },
    {
      "key": "iwe",
      "family": "miamimd-co",
      "kind": "one-time",
      "pack": 6,
      "productId": 15485378461981,
      "variantId": 67912004370717,
      "sku": "MMIWE-6B",
      "handle": "miamimd-instant-wrinkle-eraser-6-bottles-mmdco",
      "title": "MiamiMD Instant Wrinkle Eraser 6 Bottles",
      "tags": [
        "miamimd-co-import-20261029",
        "miamimd-co-price"
      ],
      "priceCents": 36000,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:57:17-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-instant-wrinkle-eraser-6-bottles-mmdco.js"
    },
    {
      "key": "iwe",
      "family": "miamimd-co",
      "kind": "one-time",
      "pack": 3,
      "productId": 15485378298141,
      "variantId": 67912001945885,
      "sku": "MMIWE-3B",
      "handle": "miamimd-instant-wrinkle-eraser-3-bottles-mmdco",
      "title": "MiamiMD Instant Wrinkle Eraser 3 Bottles",
      "tags": [
        "miamimd-co-import-20261029",
        "miamimd-co-price"
      ],
      "priceCents": 18900,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:57:15-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-instant-wrinkle-eraser-3-bottles-mmdco.js"
    },
    {
      "key": "iwe",
      "family": "miamimd-co",
      "kind": "one-time",
      "pack": 1,
      "productId": 15485378068765,
      "variantId": 67911999062301,
      "sku": "MMIWE-1B",
      "handle": "miamimd-instant-wrinkle-eraser-1-bottle-mmdco",
      "title": "MiamiMD Instant Wrinkle Eraser 1 Bottle",
      "tags": [
        "miamimd-co-import-20261029",
        "miamimd-co-price"
      ],
      "priceCents": 6900,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:57:13-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": true,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-instant-wrinkle-eraser-1-bottle-mmdco.js"
    },
    {
      "key": "iwe",
      "family": "trymiamimd",
      "kind": "subscription",
      "pack": 6,
      "productId": 15485377872157,
      "variantId": 67911996604701,
      "sku": "MMIWE-6B",
      "handle": "miamimd-instant-wrinkle-eraser-6-bottles-subscription",
      "title": "MiamiMD Instant Wrinkle Eraser 6 Bottles (Subscription)",
      "tags": [
        "miamimd-co-import-20261029",
        "trymiamimd-price"
      ],
      "priceCents": 21600,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:57:12-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-instant-wrinkle-eraser-6-bottles-subscription.js"
    },
    {
      "key": "iwe",
      "family": "trymiamimd",
      "kind": "subscription",
      "pack": 3,
      "productId": 15485377675549,
      "variantId": 67911993950493,
      "sku": "MMIWE-3B",
      "handle": "miamimd-instant-wrinkle-eraser-3-bottles-subscription",
      "title": "MiamiMD Instant Wrinkle Eraser 3 Bottles (Subscription)",
      "tags": [
        "miamimd-co-import-20261029",
        "trymiamimd-price"
      ],
      "priceCents": 11700,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:57:10-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-instant-wrinkle-eraser-3-bottles-subscription.js"
    },
    {
      "key": "iwe",
      "family": "trymiamimd",
      "kind": "subscription",
      "pack": 1,
      "productId": 15485377577245,
      "variantId": 67911993819421,
      "sku": "MMIWE-1B",
      "handle": "miamimd-instant-wrinkle-eraser-1-bottle-subscription",
      "title": "MiamiMD Instant Wrinkle Eraser 1 Bottle (Subscription)",
      "tags": [
        "miamimd-co-import-20261029",
        "trymiamimd-price"
      ],
      "priceCents": 4400,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:57:09-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-instant-wrinkle-eraser-1-bottle-subscription.js"
    },
    {
      "key": "cleanser",
      "family": "special",
      "kind": "special",
      "pack": 6,
      "productId": 15485376266525,
      "variantId": 67911982907677,
      "sku": "MMFC-6B",
      "handle": "miamimd-facial-cleanser-6-tubes-special",
      "title": "MiamiMD Facial Cleanser 6 Tubes (Special)",
      "tags": [
        "miamimd-co-import-20261029",
        "Special"
      ],
      "priceCents": 12600,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:57:07-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": true,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-facial-cleanser-6-tubes-special.js"
    },
    {
      "key": "cleanser",
      "family": "special",
      "kind": "special",
      "pack": 3,
      "productId": 15485376037149,
      "variantId": 67911980417309,
      "sku": "MMFC-3B",
      "handle": "miamimd-facial-cleanser-3-tubes-special",
      "title": "MiamiMD Facial Cleanser 3 Tubes (Special)",
      "tags": [
        "miamimd-co-import-20261029",
        "Special"
      ],
      "priceCents": 6930,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:57:05-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-facial-cleanser-3-tubes-special.js"
    },
    {
      "key": "cleanser",
      "family": "special",
      "kind": "special",
      "pack": 1,
      "productId": 15485375807773,
      "variantId": 67911977369885,
      "sku": "MMFC-1B",
      "handle": "miamimd-facial-cleanser-1-tube-special",
      "title": "MiamiMD Facial Cleanser 1 Tube (Special)",
      "tags": [
        "miamimd-co-import-20261029",
        "Special"
      ],
      "priceCents": 2730,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:57:03-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-facial-cleanser-1-tube-special.js"
    },
    {
      "key": "cleanser",
      "family": "miamimd-co",
      "kind": "subscription",
      "pack": 6,
      "productId": 15485375676701,
      "variantId": 67911975534877,
      "sku": "MMFC-6B",
      "handle": "miamimd-facial-cleanser-6-tubes-subscription-mmdco",
      "title": "MiamiMD Facial Cleanser 6 Tubes (Subscription)",
      "tags": [
        "miamimd-co-import-20261029",
        "miamimd-co-price"
      ],
      "priceCents": 16200,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:57:02-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-facial-cleanser-6-tubes-subscription-mmdco.js"
    },
    {
      "key": "cleanser",
      "family": "miamimd-co",
      "kind": "subscription",
      "pack": 3,
      "productId": 15485375480093,
      "variantId": 67911973110045,
      "sku": "MMFC-3B",
      "handle": "miamimd-facial-cleanser-3-tubes-subscription-mmdco",
      "title": "MiamiMD Facial Cleanser 3 Tubes (Subscription)",
      "tags": [
        "miamimd-co-import-20261029",
        "miamimd-co-price"
      ],
      "priceCents": 9000,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:57:00-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-facial-cleanser-3-tubes-subscription-mmdco.js"
    },
    {
      "key": "cleanser",
      "family": "miamimd-co",
      "kind": "subscription",
      "pack": 1,
      "productId": 15485375185181,
      "variantId": 67911969800477,
      "sku": "MMFC-1B",
      "handle": "miamimd-facial-cleanser-1-tube-subscription-mmdco",
      "title": "MiamiMD Facial Cleanser 1 Tube (Subscription)",
      "tags": [
        "miamimd-co-import-20261029",
        "miamimd-co-price"
      ],
      "priceCents": 3500,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:56:58-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-facial-cleanser-1-tube-subscription-mmdco.js"
    },
    {
      "key": "dsc",
      "family": "special",
      "kind": "special",
      "pack": 6,
      "productId": 15485374464285,
      "variantId": 67911959478557,
      "sku": "MMDSC-6B",
      "handle": "miamimd-dark-spot-corrector-6-bottles-special",
      "title": "MiamiMD Dark Spot Corrector 6 Bottles (Special)",
      "tags": [
        "miamimd-co-import-20261029",
        "Special"
      ],
      "priceCents": 18000,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:56:56-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-dark-spot-corrector-6-bottles-special.js"
    },
    {
      "key": "dsc",
      "family": "special",
      "kind": "special",
      "pack": 3,
      "productId": 15485350609181,
      "variantId": 67911687700765,
      "sku": "MMDSC-3B",
      "handle": "miamimd-dark-spot-corrector-3-bottles-special",
      "title": "MiamiMD Dark Spot Corrector 3 Bottles (Special)",
      "tags": [
        "miamimd-co-import-20261029",
        "Special"
      ],
      "priceCents": 9900,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:56:54-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-dark-spot-corrector-3-bottles-special.js"
    },
    {
      "key": "dsc",
      "family": "special",
      "kind": "special",
      "pack": 1,
      "productId": 15485350543645,
      "variantId": 67911687602461,
      "sku": "MMDSC-1B",
      "handle": "miamimd-dark-spot-corrector-1-bottle-special",
      "title": "MiamiMD Dark Spot Corrector 1 Bottle (Special)",
      "tags": [
        "miamimd-co-import-20261029",
        "Special"
      ],
      "priceCents": 3300,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:56:52-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-dark-spot-corrector-1-bottle-special.js"
    },
    {
      "key": "dsc",
      "family": "miamimd-co",
      "kind": "subscription",
      "pack": 6,
      "productId": 15485350478109,
      "variantId": 67911687504157,
      "sku": "MMDSC-6B",
      "handle": "miamimd-dark-spot-corrector-6-bottles-subscription-mmdco",
      "title": "MiamiMD Dark Spot Corrector 6 Bottles (Subscription)",
      "tags": [
        "miamimd-co-import-20261029",
        "miamimd-co-price"
      ],
      "priceCents": 32400,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:56:50-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-dark-spot-corrector-6-bottles-subscription-mmdco.js"
    },
    {
      "key": "dsc",
      "family": "miamimd-co",
      "kind": "subscription",
      "pack": 3,
      "productId": 15485350379805,
      "variantId": 67911687405853,
      "sku": "MMDSC-3B",
      "handle": "miamimd-dark-spot-corrector-3-bottles-subscription-mmdco",
      "title": "MiamiMD Dark Spot Corrector 3 Bottles (Subscription)",
      "tags": [
        "miamimd-co-import-20261029",
        "miamimd-co-price"
      ],
      "priceCents": 17100,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:56:49-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-dark-spot-corrector-3-bottles-subscription-mmdco.js"
    },
    {
      "key": "dsc",
      "family": "miamimd-co",
      "kind": "subscription",
      "pack": 1,
      "productId": 15485350248733,
      "variantId": 67911687242013,
      "sku": "MMDSC-1B",
      "handle": "miamimd-dark-spot-corrector-1-bottle-subscription-mmdco",
      "title": "MiamiMD Dark Spot Corrector 1 Bottle (Subscription)",
      "tags": [
        "miamimd-co-import-20261029",
        "miamimd-co-price"
      ],
      "priceCents": 6200,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:56:47-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-dark-spot-corrector-1-bottle-subscription-mmdco.js"
    },
    {
      "key": "dsc",
      "family": "miamimd-co",
      "kind": "one-time",
      "pack": 6,
      "productId": 15485350183197,
      "variantId": 67911687143709,
      "sku": "MMDSC-6B",
      "handle": "miamimd-dark-spot-corrector-6-bottles-mmdco",
      "title": "MiamiMD Dark Spot Corrector 6 Bottles",
      "tags": [
        "miamimd-co-import-20261029",
        "miamimd-co-price"
      ],
      "priceCents": 36000,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:56:45-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-dark-spot-corrector-6-bottles-mmdco.js"
    },
    {
      "key": "dsc",
      "family": "miamimd-co",
      "kind": "one-time",
      "pack": 3,
      "productId": 15485350117661,
      "variantId": 67911687045405,
      "sku": "MMDSC-3B",
      "handle": "miamimd-dark-spot-corrector-3-bottles-mmdco",
      "title": "MiamiMD Dark Spot Corrector 3 Bottles",
      "tags": [
        "miamimd-co-import-20261029",
        "miamimd-co-price"
      ],
      "priceCents": 18900,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:56:43-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-dark-spot-corrector-3-bottles-mmdco.js"
    },
    {
      "key": "dsc",
      "family": "miamimd-co",
      "kind": "one-time",
      "pack": 1,
      "productId": 15485350052125,
      "variantId": 67911686947101,
      "sku": "MMDSC-1B",
      "handle": "miamimd-dark-spot-corrector-1-bottle-mmdco",
      "title": "MiamiMD Dark Spot Corrector 1 Bottle",
      "tags": [
        "miamimd-co-import-20261029",
        "miamimd-co-price"
      ],
      "priceCents": 6900,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:56:41-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-dark-spot-corrector-1-bottle-mmdco.js"
    },
    {
      "key": "dsc",
      "family": "trymiamimd",
      "kind": "subscription",
      "pack": 6,
      "productId": 15485349888285,
      "variantId": 67911686783261,
      "sku": "MMDSC-6B",
      "handle": "miamimd-dark-spot-corrector-6-bottles-subscription",
      "title": "MiamiMD Dark Spot Corrector 6 Bottles (Subscription)",
      "tags": [
        "miamimd-co-import-20261029",
        "trymiamimd-price"
      ],
      "priceCents": 21600,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:56:39-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": true,
      "plans": [
        {
          "id": 691073810717,
          "rechargePlanId": "23631652",
          "appId": "294517",
          "interval": "MONTH",
          "intervalCount": 1,
          "cadenceEvidence": "structured selling-plan option, not plan name",
          "priceCents": 21600,
          "perDeliveryPriceCents": 21600,
          "allocationVerified": true,
          "billingPolicyAdminVerified": false,
          "rechargeProductQuantityOption": "0"
        },
        {
          "id": 691073843485,
          "rechargePlanId": "23631653",
          "appId": "294517",
          "interval": "MONTH",
          "intervalCount": 3,
          "cadenceEvidence": "structured selling-plan option, not plan name",
          "priceCents": 21600,
          "perDeliveryPriceCents": 21600,
          "allocationVerified": true,
          "billingPolicyAdminVerified": false,
          "rechargeProductQuantityOption": "0"
        },
        {
          "id": 691078299933,
          "rechargePlanId": "23631654",
          "appId": "294517",
          "interval": "MONTH",
          "intervalCount": 6,
          "cadenceEvidence": "structured selling-plan option, not plan name",
          "priceCents": 21600,
          "perDeliveryPriceCents": 21600,
          "allocationVerified": true,
          "billingPolicyAdminVerified": false,
          "rechargeProductQuantityOption": "0"
        }
      ],
      "source": "https://crepe.trymiamimd.com/products/miamimd-dark-spot-corrector-6-bottles-subscription.js"
    },
    {
      "key": "dsc",
      "family": "trymiamimd",
      "kind": "subscription",
      "pack": 1,
      "productId": 15485349822749,
      "variantId": 67911686652189,
      "sku": "MMDSC-1B",
      "handle": "miamimd-dark-spot-corrector-1-bottle-subscription",
      "title": "MiamiMD Dark Spot Corrector 1 Bottle (Subscription)",
      "tags": [
        "miamimd-co-import-20261029",
        "trymiamimd-price"
      ],
      "priceCents": 4400,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:56:38-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-dark-spot-corrector-1-bottle-subscription.js"
    },
    {
      "key": "lf",
      "family": "special",
      "kind": "special",
      "pack": 6,
      "productId": 15485349626141,
      "variantId": 67911686390045,
      "sku": "MMLFC-6B",
      "handle": "miamimd-lift-and-firm-cream-6-jars-special",
      "title": "MiamiMD Lift & Firm Cream 6 Jars (Special)",
      "tags": [
        "miamimd-co-import-20261029",
        "Special"
      ],
      "priceCents": 18000,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:56:36-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-lift-and-firm-cream-6-jars-special.js"
    },
    {
      "key": "lf",
      "family": "special",
      "kind": "special",
      "pack": 3,
      "productId": 15485349527837,
      "variantId": 67911685996829,
      "sku": "MMLFC-3B",
      "handle": "miamimd-lift-and-firm-cream-3-jars-special",
      "title": "MiamiMD Lift & Firm Cream 3 Jars (Special)",
      "tags": [
        "miamimd-co-import-20261029",
        "Special"
      ],
      "priceCents": 9900,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:56:34-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-lift-and-firm-cream-3-jars-special.js"
    },
    {
      "key": "lf",
      "family": "special",
      "kind": "special",
      "pack": 1,
      "productId": 15485349363997,
      "variantId": 67911685538077,
      "sku": "MMLFC-1B",
      "handle": "miamimd-lift-and-firm-cream-1-jar-special",
      "title": "MiamiMD Lift & Firm Cream 1 Jar (Special)",
      "tags": [
        "miamimd-co-import-20261029",
        "Special"
      ],
      "priceCents": 3300,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:56:33-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-lift-and-firm-cream-1-jar-special.js"
    },
    {
      "key": "lf",
      "family": "miamimd-co",
      "kind": "subscription",
      "pack": 6,
      "productId": 15485349298461,
      "variantId": 67911685210397,
      "sku": "MMLFC-6B",
      "handle": "miamimd-lift-and-firm-cream-6-jars-subscription-mmdco",
      "title": "MiamiMD Lift & Firm Cream 6 Jars (Subscription)",
      "tags": [
        "miamimd-co-import-20261029",
        "miamimd-co-price"
      ],
      "priceCents": 32400,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:56:31-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-lift-and-firm-cream-6-jars-subscription-mmdco.js"
    },
    {
      "key": "lf",
      "family": "miamimd-co",
      "kind": "subscription",
      "pack": 3,
      "productId": 15485349232925,
      "variantId": 67911685112093,
      "sku": "MMLFC-3B",
      "handle": "miamimd-lift-and-firm-cream-3-jars-subscription-mmdco",
      "title": "MiamiMD Lift & Firm Cream 3 Jars (Subscription)",
      "tags": [
        "miamimd-co-import-20261029",
        "miamimd-co-price"
      ],
      "priceCents": 17100,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:56:29-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-lift-and-firm-cream-3-jars-subscription-mmdco.js"
    },
    {
      "key": "lf",
      "family": "miamimd-co",
      "kind": "subscription",
      "pack": 1,
      "productId": 15485349101853,
      "variantId": 67911684948253,
      "sku": "MMLFC-1B",
      "handle": "miamimd-lift-and-firm-cream-1-jar-subscription-mmdco",
      "title": "MiamiMD Lift & Firm Cream 1 Jar (Subscription)",
      "tags": [
        "miamimd-co-import-20261029",
        "miamimd-co-price"
      ],
      "priceCents": 6200,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:56:28-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-lift-and-firm-cream-1-jar-subscription-mmdco.js"
    },
    {
      "key": "lf",
      "family": "miamimd-co",
      "kind": "one-time",
      "pack": 6,
      "productId": 15485349003549,
      "variantId": 67911684751645,
      "sku": "MMLFC-6B",
      "handle": "miamimd-lift-and-firm-cream-6-jars-mmdco",
      "title": "MiamiMD Lift & Firm Cream 6 Jars",
      "tags": [
        "miamimd-co-import-20261029",
        "miamimd-co-price"
      ],
      "priceCents": 36000,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:56:26-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-lift-and-firm-cream-6-jars-mmdco.js"
    },
    {
      "key": "lf",
      "family": "miamimd-co",
      "kind": "one-time",
      "pack": 3,
      "productId": 15485348970781,
      "variantId": 67911684718877,
      "sku": "MMLFC-3B",
      "handle": "miamimd-lift-and-firm-cream-3-jars-mmdco",
      "title": "MiamiMD Lift & Firm Cream 3 Jars",
      "tags": [
        "miamimd-co-import-20261029",
        "miamimd-co-price"
      ],
      "priceCents": 18900,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:56:24-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-lift-and-firm-cream-3-jars-mmdco.js"
    },
    {
      "key": "lf",
      "family": "miamimd-co",
      "kind": "one-time",
      "pack": 1,
      "productId": 15485348872477,
      "variantId": 67911684522269,
      "sku": "MMLFC-1B",
      "handle": "miamimd-lift-and-firm-cream-1-jar-mmdco",
      "title": "MiamiMD Lift & Firm Cream 1 Jar",
      "tags": [
        "miamimd-co-import-20261029",
        "miamimd-co-price"
      ],
      "priceCents": 6900,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:56:23-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-lift-and-firm-cream-1-jar-mmdco.js"
    },
    {
      "key": "acf",
      "family": "miamimd-co",
      "kind": "subscription",
      "pack": 6,
      "productId": 15485348806941,
      "variantId": 67911684423965,
      "sku": "MMACF-6B",
      "handle": "miamimd-advanced-crepe-fix-6-bottles-subscription-mmdco",
      "title": "MiamiMD Advanced Crepe Fix 6 Bottles (Subscription)",
      "tags": [
        "miamimd-co-import-20261029",
        "miamimd-co-price"
      ],
      "priceCents": 32400,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:56:21-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-advanced-crepe-fix-6-bottles-subscription-mmdco.js"
    },
    {
      "key": "acf",
      "family": "miamimd-co",
      "kind": "subscription",
      "pack": 3,
      "productId": 15485348741405,
      "variantId": 67911684325661,
      "sku": "MMACF-3B",
      "handle": "miamimd-advanced-crepe-fix-3-bottles-subscription-mmdco",
      "title": "MiamiMD Advanced Crepe Fix 3 Bottles (Subscription)",
      "tags": [
        "miamimd-co-import-20261029",
        "miamimd-co-price"
      ],
      "priceCents": 17100,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:56:20-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-advanced-crepe-fix-3-bottles-subscription-mmdco.js"
    },
    {
      "key": "acf",
      "family": "miamimd-co",
      "kind": "subscription",
      "pack": 1,
      "productId": 15485348708637,
      "variantId": 67911684260125,
      "sku": "MMACF-1B",
      "handle": "miamimd-advanced-crepe-fix-1-bottle-subscription-mmdco",
      "title": "MiamiMD Advanced Crepe Fix 1 Bottle (Subscription)",
      "tags": [
        "miamimd-co-import-20261029",
        "miamimd-co-price"
      ],
      "priceCents": 6200,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:56:18-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-advanced-crepe-fix-1-bottle-subscription-mmdco.js"
    },
    {
      "key": "acf",
      "family": "miamimd-co",
      "kind": "one-time",
      "pack": 6,
      "productId": 15485348643101,
      "variantId": 67911684194589,
      "sku": "MMACF-6B",
      "handle": "miamimd-advanced-crepe-fix-6-bottles-mmdco",
      "title": "MiamiMD Advanced Crepe Fix 6 Bottles",
      "tags": [
        "miamimd-co-import-20261029",
        "miamimd-co-price"
      ],
      "priceCents": 36000,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:56:17-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-advanced-crepe-fix-6-bottles-mmdco.js"
    },
    {
      "key": "acf",
      "family": "miamimd-co",
      "kind": "one-time",
      "pack": 3,
      "productId": 15485348577565,
      "variantId": 67911684096285,
      "sku": "MMACF-3B",
      "handle": "miamimd-advanced-crepe-fix-3-bottles-mmdco",
      "title": "MiamiMD Advanced Crepe Fix 3 Bottles",
      "tags": [
        "miamimd-co-import-20261029",
        "miamimd-co-price"
      ],
      "priceCents": 18900,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:56:15-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-advanced-crepe-fix-3-bottles-mmdco.js"
    },
    {
      "key": "acf",
      "family": "miamimd-co",
      "kind": "one-time",
      "pack": 1,
      "productId": 15485348446493,
      "variantId": 67911683932445,
      "sku": "MMACF-1B",
      "handle": "miamimd-advanced-crepe-fix-1-bottle-mmdco",
      "title": "MiamiMD Advanced Crepe Fix 1 Bottle",
      "tags": [
        "miamimd-co-import-20261029",
        "miamimd-co-price"
      ],
      "priceCents": 6900,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:56:13-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-advanced-crepe-fix-1-bottle-mmdco.js"
    },
    {
      "key": "dsc",
      "family": "trymiamimd",
      "kind": "subscription",
      "pack": 3,
      "productId": 15484624765213,
      "variantId": 67907286565149,
      "sku": "MMDSC-3B",
      "handle": "miamimd-dark-spot-corrector-3-bottles-subscription",
      "title": "MiamiMD Dark Spot Corrector 3 Bottles (Subscription)",
      "tags": [
        "miamimd-co-import-20261029",
        "trymiamimd-price"
      ],
      "priceCents": 11700,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:56:12-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-dark-spot-corrector-3-bottles-subscription.js"
    },
    {
      "key": "lip",
      "family": "trymiamimd",
      "kind": "one-time",
      "pack": 6,
      "productId": 15479673356573,
      "variantId": 67882018373917,
      "sku": "MMLP-6B",
      "handle": "miamimd-lip-plumper-6-pack",
      "title": "MiamiMD Lip Plumper 6 Bottles",
      "tags": [
        "fulfillment-review-required",
        "miamimd-catalog-20261026",
        "miamimd-co-import-20261029",
        "trymiamimd-price"
      ],
      "priceCents": 24000,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:56:09-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-lip-plumper-6-pack.js"
    },
    {
      "key": "lip",
      "family": "trymiamimd",
      "kind": "one-time",
      "pack": 3,
      "productId": 15479673291037,
      "variantId": 67882018308381,
      "sku": "MMLP-3B",
      "handle": "miamimd-lip-plumper-3-pack",
      "title": "MiamiMD Lip Plumper 3 Bottles",
      "tags": [
        "fulfillment-review-required",
        "miamimd-catalog-20261026",
        "miamimd-co-import-20261029",
        "trymiamimd-price"
      ],
      "priceCents": 12900,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:56:07-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-lip-plumper-3-pack.js"
    },
    {
      "key": "lip",
      "family": "trymiamimd",
      "kind": "one-time",
      "pack": 1,
      "productId": 15479673225501,
      "variantId": 67882018242845,
      "sku": "MMLP-1B",
      "handle": "miamimd-lip-plumper-1-pack",
      "title": "MiamiMD Lip Plumper 1 Bottle",
      "tags": [
        "fulfillment-review-required",
        "miamimd-catalog-20261026",
        "miamimd-co-import-20261029",
        "trymiamimd-price"
      ],
      "priceCents": 4900,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:56:05-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-lip-plumper-1-pack.js"
    },
    {
      "key": "cleanser",
      "family": "miamimd-co",
      "kind": "one-time",
      "pack": 6,
      "productId": 15479673192733,
      "variantId": 67882018210077,
      "sku": "MMFC-6B",
      "handle": "miamimd-facial-cleanser-6-pack",
      "title": "MiamiMD Facial Cleanser 6 Tubes",
      "tags": [
        "fulfillment-review-required",
        "miamimd-catalog-20261026",
        "miamimd-co-import-20261029",
        "miamimd-co-price"
      ],
      "priceCents": 18000,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:56:03-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-facial-cleanser-6-pack.js"
    },
    {
      "key": "cleanser",
      "family": "miamimd-co",
      "kind": "one-time",
      "pack": 3,
      "productId": 15479673127197,
      "variantId": 67882018144541,
      "sku": "MMFC-3B",
      "handle": "miamimd-facial-cleanser-3-pack",
      "title": "MiamiMD Facial Cleanser 3 Tubes",
      "tags": [
        "fulfillment-review-required",
        "miamimd-catalog-20261026",
        "miamimd-co-import-20261029",
        "miamimd-co-price"
      ],
      "priceCents": 9900,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:56:01-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-facial-cleanser-3-pack.js"
    },
    {
      "key": "cleanser",
      "family": "miamimd-co",
      "kind": "one-time",
      "pack": 1,
      "productId": 15479673028893,
      "variantId": 67882018046237,
      "sku": "MMFC-1B",
      "handle": "miamimd-facial-cleanser-1-pack",
      "title": "MiamiMD Facial Cleanser 1 Tube",
      "tags": [
        "fulfillment-review-required",
        "miamimd-catalog-20261026",
        "miamimd-co-import-20261029",
        "miamimd-co-price"
      ],
      "priceCents": 3900,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:55:59-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-facial-cleanser-1-pack.js"
    },
    {
      "key": "iwe",
      "family": "trymiamimd",
      "kind": "one-time",
      "pack": 6,
      "productId": 15479672963357,
      "variantId": 67882017980701,
      "sku": "MMIWE-6B",
      "handle": "miamimd-instant-wrinkle-eraser-6-pack",
      "title": "MiamiMD Instant Wrinkle Eraser 6 Bottles",
      "tags": [
        "fulfillment-review-required",
        "miamimd-catalog-20261026",
        "miamimd-co-import-20261029",
        "trymiamimd-price"
      ],
      "priceCents": 24000,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:55:56-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-instant-wrinkle-eraser-6-pack.js"
    },
    {
      "key": "iwe",
      "family": "trymiamimd",
      "kind": "one-time",
      "pack": 3,
      "productId": 15479672897821,
      "variantId": 67882017915165,
      "sku": "MMIWE-3B",
      "handle": "miamimd-instant-wrinkle-eraser-3-pack",
      "title": "MiamiMD Instant Wrinkle Eraser 3 Bottles",
      "tags": [
        "fulfillment-review-required",
        "miamimd-catalog-20261026",
        "miamimd-co-import-20261029",
        "trymiamimd-price"
      ],
      "priceCents": 12900,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:55:54-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-instant-wrinkle-eraser-3-pack.js"
    },
    {
      "key": "iwe",
      "family": "trymiamimd",
      "kind": "one-time",
      "pack": 1,
      "productId": 15479672832285,
      "variantId": 67882017849629,
      "sku": "MMIWE-1B",
      "handle": "miamimd-instant-wrinkle-eraser-1-pack",
      "title": "MiamiMD Instant Wrinkle Eraser 1 Bottle",
      "tags": [
        "fulfillment-review-required",
        "miamimd-catalog-20261026",
        "miamimd-co-import-20261029",
        "trymiamimd-price"
      ],
      "priceCents": 4900,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:55:52-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-instant-wrinkle-eraser-1-pack.js"
    },
    {
      "key": "tbm",
      "family": "trymiamimd",
      "kind": "one-time",
      "pack": 6,
      "productId": 15479671816477,
      "variantId": 67882016473373,
      "sku": "MMTBM-6B",
      "handle": "miamimd-total-beauty-matrix-6-pack",
      "title": "MiamiMD Total Beauty Matrix 6 Jars",
      "tags": [
        "fulfillment-review-required",
        "miamimd-catalog-20261026",
        "miamimd-co-import-20261029",
        "trymiamimd-price"
      ],
      "priceCents": 24000,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:55:26-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-total-beauty-matrix-6-pack.js"
    },
    {
      "key": "tbm",
      "family": "trymiamimd",
      "kind": "one-time",
      "pack": 3,
      "productId": 15479671750941,
      "variantId": 67882016407837,
      "sku": "MMTBM-3B",
      "handle": "miamimd-total-beauty-matrix-3-pack",
      "title": "MiamiMD Total Beauty Matrix 3 Jars",
      "tags": [
        "fulfillment-review-required",
        "miamimd-catalog-20261026",
        "miamimd-co-import-20261029",
        "trymiamimd-price"
      ],
      "priceCents": 12900,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:55:24-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-total-beauty-matrix-3-pack.js"
    },
    {
      "key": "tbm",
      "family": "trymiamimd",
      "kind": "one-time",
      "pack": 1,
      "productId": 15479671685405,
      "variantId": 67882016342301,
      "sku": "MMTBM-1B",
      "handle": "miamimd-total-beauty-matrix-1-pack",
      "title": "MiamiMD Total Beauty Matrix 1 Jar",
      "tags": [
        "fulfillment-review-required",
        "miamimd-catalog-20261026",
        "miamimd-co-import-20261029",
        "trymiamimd-price"
      ],
      "priceCents": 4900,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:55:22-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-total-beauty-matrix-1-pack.js"
    },
    {
      "key": "dsc",
      "family": "trymiamimd",
      "kind": "one-time",
      "pack": 6,
      "productId": 15479671587101,
      "variantId": 67882016243997,
      "sku": "MMDSC-6B",
      "handle": "miamimd-dark-spot-corrector-6-pack",
      "title": "MiamiMD Dark Spot Corrector 6 Bottles",
      "tags": [
        "fulfillment-review-required",
        "miamimd-catalog-20261026",
        "miamimd-co-import-20261029",
        "trymiamimd-price"
      ],
      "priceCents": 24000,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:55:19-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-dark-spot-corrector-6-pack.js"
    },
    {
      "key": "dsc",
      "family": "trymiamimd",
      "kind": "one-time",
      "pack": 3,
      "productId": 15479671456029,
      "variantId": 67882016112925,
      "sku": "MMDSC-3B",
      "handle": "miamimd-dark-spot-corrector-3-pack",
      "title": "MiamiMD Dark Spot Corrector 3 Bottles",
      "tags": [
        "fulfillment-review-required",
        "miamimd-catalog-20261026",
        "miamimd-co-import-20261029",
        "trymiamimd-price"
      ],
      "priceCents": 12900,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:55:17-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-dark-spot-corrector-3-pack.js"
    },
    {
      "key": "dsc",
      "family": "trymiamimd",
      "kind": "one-time",
      "pack": 1,
      "productId": 15479671357725,
      "variantId": 67882016014621,
      "sku": "MMDSC-1B",
      "handle": "miamimd-dark-spot-corrector-1-pack",
      "title": "MiamiMD Dark Spot Corrector 1 Bottle",
      "tags": [
        "fulfillment-review-required",
        "miamimd-catalog-20261026",
        "miamimd-co-import-20261029",
        "trymiamimd-price"
      ],
      "priceCents": 4900,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2026-10-29T16:55:15-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-dark-spot-corrector-1-pack.js"
    },
    {
      "key": "lf",
      "family": "legacy-untagged",
      "kind": "one-time",
      "pack": 1,
      "productId": 8379885617437,
      "variantId": 45147090714909,
      "sku": "MMADLFC-1 - Upsell",
      "handle": "copy-of-miami-md-lift-firm-cream-1-jar-downsell",
      "title": "Miami MD Lift & Firm Cream 1 Jar",
      "tags": [],
      "priceCents": 3300,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2023-06-15T07:41:18-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/copy-of-miami-md-lift-firm-cream-1-jar-downsell.js"
    },
    {
      "key": "lf",
      "family": "legacy-untagged",
      "kind": "one-time",
      "pack": 1,
      "productId": 8379855470877,
      "variantId": 45147044118813,
      "sku": "MMADLFC-1 - Upsell",
      "handle": "miami-md-lift-firm-cream-3-jars",
      "title": "Miami MD Lift & Firm Cream 1 Jar",
      "tags": [],
      "priceCents": 4900,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2023-06-15T07:31:50-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miami-md-lift-firm-cream-3-jars.js"
    },
    {
      "key": "lf",
      "family": "legacy-untagged",
      "kind": "one-time",
      "pack": 3,
      "productId": 8379849441565,
      "variantId": 45147034943773,
      "sku": "MMADLFC-3 - Upsell",
      "handle": "miami-md-lift-firm-cream",
      "title": "Miami MD Lift & Firm Cream 3 Jars",
      "tags": [],
      "priceCents": 12900,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2023-06-15T07:30:16-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miami-md-lift-firm-cream.js"
    },
    {
      "key": "lf",
      "family": "legacy-untagged",
      "kind": "one-time",
      "pack": 6,
      "productId": 8377795445021,
      "variantId": 45139815956765,
      "sku": "MMADLFC-6 - Upsell",
      "handle": "miamimd-lift-firm-cream-6-jars",
      "title": "MiamiMD Lift & Firm Cream 6 Jars",
      "tags": [],
      "priceCents": 24000,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2023-06-14T08:55:26-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-lift-firm-cream-6-jars.js"
    },
    {
      "key": "acf",
      "family": "special",
      "kind": "special",
      "pack": 1,
      "productId": 8376105632029,
      "variantId": 45135481012509,
      "sku": "MMACF-1-Upsell",
      "handle": "miamimd-advanced-crepe-fix-1-jar-special",
      "title": "MiamiMD Advanced Crepe Fix 1 Jar (Special)",
      "tags": [],
      "priceCents": 3300,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2023-06-13T13:43:05-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-advanced-crepe-fix-1-jar-special.js"
    },
    {
      "key": "acf",
      "family": "special",
      "kind": "special",
      "pack": 3,
      "productId": 8376104878365,
      "variantId": 45135478849821,
      "sku": "MMACF-3-Upsell",
      "handle": "miamimd-advanced-crepe-fix-3-jars-special",
      "title": "MiamiMD Advanced Crepe Fix 3 Jars (Special)",
      "tags": [],
      "priceCents": 9900,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2023-06-13T13:42:00-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-advanced-crepe-fix-3-jars-special.js"
    },
    {
      "key": "acf",
      "family": "special",
      "kind": "special",
      "pack": 6,
      "productId": 8376104124701,
      "variantId": 45135473639709,
      "sku": "MMACF-6-Upsell",
      "handle": "miamimd-advanced-crepe-fix-6-jars-special",
      "title": "MiamiMD Advanced Crepe Fix 6 Jars (Special)",
      "tags": [],
      "priceCents": 18000,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2023-06-13T13:40:56-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/miamimd-advanced-crepe-fix-6-jars-special.js"
    },
    {
      "key": "acf",
      "family": "legacy-untagged",
      "kind": "subscription",
      "pack": 6,
      "productId": 8362465788189,
      "variantId": 45089686094109,
      "sku": "MMACF-6",
      "handle": "advanced-crepe-fix-6-jars-subscription",
      "title": "Advanced Crepe Fix 6 Jars (Subscription)",
      "tags": [],
      "priceCents": 21600,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2023-06-06T05:56:15-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/advanced-crepe-fix-6-jars-subscription.js"
    },
    {
      "key": "acf",
      "family": "legacy-untagged",
      "kind": "subscription",
      "pack": 3,
      "productId": 8362465493277,
      "variantId": 45089684488477,
      "sku": "MMACF-3",
      "handle": "advanced-crepe-fix-3-jars-subscription",
      "title": "Advanced Crepe Fix 3 Jars (Subscription)",
      "tags": [],
      "priceCents": 11700,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2023-06-06T05:55:11-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/advanced-crepe-fix-3-jars-subscription.js"
    },
    {
      "key": "acf",
      "family": "legacy-untagged",
      "kind": "subscription",
      "pack": 1,
      "productId": 8362464608541,
      "variantId": 45089681146141,
      "sku": "MMACF-1",
      "handle": "advanced-crepe-fix-1-jar-subscription",
      "title": "Advanced Crepe Fix 1 Jar (Subscription)",
      "tags": [],
      "priceCents": 4400,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2023-06-06T05:54:14-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/advanced-crepe-fix-1-jar-subscription.js"
    },
    {
      "key": "acf",
      "family": "legacy-untagged",
      "kind": "one-time",
      "pack": 3,
      "productId": 8362463756573,
      "variantId": 45089678557469,
      "sku": "MMACF-3",
      "handle": "copy-of-advanced-crepe-fix-1-jar",
      "title": "Advanced Crepe Fix 3 Jars",
      "tags": [],
      "priceCents": 12900,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2023-06-06T05:52:47-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/copy-of-advanced-crepe-fix-1-jar.js"
    },
    {
      "key": "acf",
      "family": "legacy-untagged",
      "kind": "one-time",
      "pack": 6,
      "productId": 8362464149789,
      "variantId": 45089679540509,
      "sku": "MMACF-6",
      "handle": "copy-of-advanced-crepe-fix-3-jars",
      "title": "Advanced Crepe Fix 6 Jars",
      "tags": [],
      "priceCents": 24000,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2023-06-06T05:52:27-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/copy-of-advanced-crepe-fix-3-jars.js"
    },
    {
      "key": "acf",
      "family": "legacy-untagged",
      "kind": "one-time",
      "pack": 1,
      "productId": 8336468836637,
      "variantId": 45018555416861,
      "sku": "MMACF-1",
      "handle": "advanced-crepe-fix",
      "title": "Advanced Crepe Fix 1 Jar",
      "tags": [],
      "priceCents": 4900,
      "publicAvailable": true,
      "grams": 0,
      "publishedAt": "2023-05-25T08:12:29-04:00",
      "warehouseVerified": false,
      "locationInventoryVerified": false,
      "inventoryQuantity": null,
      "publicPlanReadbackVerified": false,
      "plans": [],
      "source": "https://crepe.trymiamimd.com/products/advanced-crepe-fix.js"
    }
  ]
};
function inspect(choice){
 const record=registry.records.find(r=>r.productId===choice.productId&&r.variantId===choice.variantId);const reasons=[];
 if(!record)return {ok:false,purchaseEnabled:false,reasons:['Unknown exact product/variant pair']};
 if(choice.family!==record.family)reasons.push('Pricing family mismatch');
 if(choice.sellingPlanId){const plan=record.plans.find(p=>p.id===choice.sellingPlanId);if(!plan)reasons.push('Exact selling-plan allocation not verified');else{if(plan.appId!=='294517'||!plan.allocationVerified||plan.priceCents!==choice.priceCents||plan.intervalCount!==choice.intervalMonths)reasons.push('Plan price, app or cadence mismatch');if(!plan.billingPolicyAdminVerified)reasons.push('Private billing policy verification pending');}}
 else if(record.kind==='subscription')reasons.push('Subscription record requires exact selling plan');
 else if(choice.priceCents!==record.priceCents)reasons.push('Catalog price mismatch');
 if(!record.warehouseVerified||!record.locationInventoryVerified)reasons.push('Warehouse and inventory verification pending');
 if(!registry.defaultPricingChangeApproved)reasons.push('Offer-price selection approval pending');
 return {ok:false,purchaseEnabled:false,catalogMatch:reasons.every(x=>!x.includes('mismatch')&&!x.includes('not verified')),reasons};
}
root.MMD_CATALOG=Object.freeze({registry,inspect,purchaseEnabled:false});
if(typeof module!=='undefined')module.exports=root.MMD_CATALOG;
})(typeof window==='undefined'?globalThis:window);
